import React from 'react';
import { User } from 'lucide-react';
import FitScoreBadge from './FitScoreBadge';

const PlayerHeader = ({ player, fitScore }) => {
  const formatDOB = (dateString) => {
    if (!dateString) return 'N/A';
    const parts = dateString.split('-');
    if (parts.length !== 3) return dateString;
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  };

  const playerTypeLabel = (type) => {
    if (type === 'hs') return 'High School';
    if (type === 'college') return 'College';
    return 'NFL';
  };

  return (
    <div className="panel-card fade-in mb-4 md:mb-6">
      <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-5 md:gap-0">
        {/* Left Side - Player Info */}
        <div className="flex gap-4 md:gap-6 min-w-0">
          {/* Photo */}
          <div className="w-24 h-24 md:w-32 md:h-32 flex-shrink-0 bg-[#243B55] rounded-lg border border-[#546E7A]/50 flex items-center justify-center overflow-hidden">
            {player.photo_url ? (
              <img
                src={player.photo_url.startsWith('http') ? player.photo_url : `https://hs.aida-advisory.com${player.photo_url}`}
                alt={player.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <User className="w-12 h-12 md:w-16 md:h-16 text-[#546E7A]" />
            )}
          </div>

          {/* Details */}
          <div className="flex flex-col justify-center gap-2 min-w-0">
            <h1 className="text-white font-bold text-2xl md:text-4xl break-words">{player.name}</h1>
            <div className="flex flex-col gap-1 text-[#B0BEC5]">
              <div className="text-base">
                <span className="font-semibold text-white">{player.position}</span>
                {' • '}
                {playerTypeLabel(player.player_type)}
              </div>
              <div className="text-sm">
                <span className="text-[#546E7A]">DOB:</span> {formatDOB(player.dob)}
              </div>
              {player.player_type === 'hs' ? (
                <>
                  <div className="text-sm">
                    <span className="text-[#546E7A]">School:</span> {player.high_school || 'N/A'}
                  </div>
                  <div className="text-sm">
                    <span className="text-[#546E7A]">Class:</span> {player.class_year || 'N/A'}
                  </div>
                </>
              ) : (
                <>
                  <div className="text-sm">
                    <span className="text-[#546E7A]">{player.player_type === 'college' ? 'College:' : 'Team:'}</span> {player.college || player.nfl_team || 'N/A'}
                  </div>
                  <div className="text-sm">
                    <span className="text-[#546E7A]">Experience:</span> {player.nfl_experience ? `${player.nfl_experience} years` : 'Rookie'}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Right Side - FitScore Badge */}
        <FitScoreBadge
          score={fitScore.overall}
          tier={fitScore.tier}
          highlights={fitScore.highlights}
        />
      </div>
    </div>
  );
};

export default PlayerHeader;
